import React, { useState } from 'react';
import './LentileDeContact.css';
import ContactForm from '../../component/ContactForm';
import CategoryCard from '../../component/CategoryCard';
import miopieImg from '../../assets/Miopia.jpg';
import astigmatismImg from '../../assets/ASTIGMATISM.jpg';
import hipermetropieImg from '../../assets/HYPERMETROPIA.jpg';
import prezbiopieImg from '../../assets/PRESMETIOPIA.jpg';
import { motion } from 'framer-motion'; // Animații

export default function LentileDeContact() {
    const [selectedCategory, setSelectedCategory] = useState('');

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        alert(`Ai selectat categoria: ${category}`);
    };

    const images = {
        Miopia: miopieImg,
        Astigmatism: astigmatismImg,
        Hipermetropie: hipermetropieImg,
        Prezbiopie: prezbiopieImg,
    };

    return (
        <div className="lentile-page">
            {/* Hero Section */}
            <motion.div 
                className="hero-section position-relative"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
            >
                <img src="./imagini/Lentile de contact.jpg" className="hero-image img-fluid" alt="Lentile de contact" />
                <div className="overlay position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center text-white">
                    <h1 className="main-title">LENTILE DE CONTACT</h1>
                    <h4 className="subtitle">Consultanță profesională</h4>
                    
                </div>
            </motion.div>

            {/* Estetica naturală Section */}
            <motion.div
                className="container text-center my-5"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <div className="card text-bg-dark card-primary mx-auto" style={{ maxWidth: '900px' }}>
                    <img src="./imagini/lentile 2.jpg" className="card-img img-fluid" alt="Lentile de contact" />
                    <div className="card-img-overlay d-flex flex-column justify-content-center text-center text-white">
                        <h5 className="card-title">Estetică naturală</h5>
                        <p className="card-text">
                            Lentilele de contact sunt o alternativă tot mai uzuală a ochelarilor de vedere. Alese corespunzător și igienizate temeinic, reprezintă o modalitate de corecție mai apropiată de estetica naturală a ochiului.
                        </p>
                    </div>
                </div>
            </motion.div>

            {/* Beneficii secțiune animată */}
            <motion.div
                className="container benefits-section text-center my-5"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <h2>Beneficiile lentilelor de contact</h2>
                <div className="row text-center">
                    <div className="col-lg-4 col-md-6 col-sm-12 my-3">
                        <div className="benefit-card">
                            <i className="fas fa-eye"></i>
                            <h5>Estetică Naturală</h5>
                            <p>Corectează vederea fără a schimba aspectul tău natural.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 my-3">
                        <div className="benefit-card">
                            <i className="fas fa-hand-holding-water"></i>
                            <h5>Confort și Igienă</h5>
                            <p>Materiale de calitate care oferă confort pe durata întregii zile.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 my-3">
                        <div className="benefit-card">
                            <i className="fas fa-glasses"></i>
                            <h5>Alternative Flexibile</h5>
                            <p>Adaptate stilului tău de viață și nevoilor tale specifice.</p>
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* Secțiunea de categorii */}
            <motion.div
                className="container categories text-center my-5"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <h2>Alege lentilele pentru condiția ta vizuală</h2>
                <div className="row">
                    {["Miopia", "Astigmatism", "Hipermetropie", "Prezbiopie"].map((condition, index) => (
                        <motion.div 
                            className="col-lg-3 col-md-6 col-sm-12 mb-4" 
                            key={index} 
                            whileHover={{ scale: 1.05 }}
                            onClick={() => handleCategoryClick(condition)}
                        >
                            <CategoryCard category={condition} image={images[condition]} />
                        </motion.div>
                    ))}
                </div>
            </motion.div>

            {/* Testimoniale */}
            <motion.div
                className="container testimonials-section text-center my-5"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <h2>Ce spun clienții noștri</h2>
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <div className="testimonial-card">
                            <p>"Lentilele de contact dintr-o gama variata ,oferite de această echipă sunt extraordinare. Serviciul clienți este impecabil!"</p>
                            <h5>- Andreea P.</h5>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <div className="testimonial-card">
                            <p>"Am găsit varianta perfectă pentru mine. Recomand cu căldură!"</p>
                            <h5>- Mihai D.</h5>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <div className="testimonial-card">
                            <p>"Confortul și claritatea vizuală sunt de neegalat. Sunt extrem de mulțumită de alegerea făcută."</p>
                            <h5>- Maria S.</h5>
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* FAQ */}
            <motion.div
                className="container faq-section my-5"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <h2>Întrebări frecvente</h2>
                <div className="accordion" id="faqAccordion">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Ce tip de lentile de contact sunt potrivite pentru mine?
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                Alegerea lentilelor potrivite depinde de nevoile tale vizuale și de recomandările medicului oftalmolog.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Cum întrețin lentilele de contact?
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                Lentilele trebuie curățate și igienizate zilnic, conform instrucțiunilor oferite de producător și oftalmolog.
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>

            
            {/* Butoane social media */}
            <motion.div
                className="container social-media-section text-center my-5"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <h2>Urmează-ne pe rețelele de socializare</h2>
                <div className="social-media-buttons">
                    <a href="https://www.facebook.com/OptiZak/" className="btn btn-social btn-facebook"><i className="fab fa-facebook-f"></i> Facebook</a>
                    
                </div>
            </motion.div>
        </div>
    );
}
